import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  DialogContentText
} from '@mui/material';
import { WarningAmber, Delete } from '@mui/icons-material';
import palette from 'src/theme/palette';

const VToolDeleteModal = ({ open, onClose, valuation, onConfirm, loading }) => {
  if (!valuation) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1
        }
      }}
    >
      <DialogTitle id="delete-dialog-title" sx={{ textAlign: 'center', py: 3 }}>
        <WarningAmber
          sx={{
            fontSize: 60,
            color: palette.warning.main,
            mb: 2
          }}
        />
        <Typography
          variant="h6"
          sx={{ fontFamily: 'poppinsSemiBold', color: palette.text.primary }}
        >
          Confirm Deletion
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pb: 2 }}>
        <DialogContentText
          id="delete-dialog-description"
          sx={{ color: palette.text.secondary, fontFamily: 'poppinsRegular' }}
        >
          Are you sure you want to delete valuation tool entry for{' '}
          <strong>{valuation?.name}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 3, px: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: palette.grey[400],
            color: palette.text.primary,
            '&:hover': {
              borderColor: palette.grey[600],
              backgroundColor: palette.action.hover
            },
            minWidth: 100,
            fontFamily: 'poppinsMedium'
          }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: palette.error.main,
            color: palette.error.contrastText,
            '&:hover': {
              backgroundColor: palette.error.dark
            },
            minWidth: 100,
            fontFamily: 'poppinsMedium'
          }}
          disabled={loading}
          startIcon={<Delete />}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VToolDeleteModal;